import { Button, Menu } from '@mantine/core';
import {
  IconCheck,
  IconChevronDown,
  IconColumns,
  IconLayoutGrid,
  IconLayoutKanban
} from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useRef } from 'react';
import { useHistory } from 'react-router-dom';

interface OrderListViewMenuProps {
  showTableView: boolean;
  onShowTableViewChange: (showTableView: boolean) => void;
  storeId: string;
  disabled?: boolean;
}

export default function OrderListViewMenu({
  showTableView,
  onShowTableViewChange,
  storeId,
  disabled = false
}: OrderListViewMenuProps) {
  const { t } = useTranslation(['OrdersPage', 'WorkBoard']);
  const history = useHistory();
  const targetRef = useRef<HTMLButtonElement>(null);
  const currentView = t(`OrdersPage:viewSelector.${showTableView ? 'table' : 'cards'}`);
  const hasSingleStore = !!storeId.trim() && storeId.trim() !== 'all';

  return (
    <Menu position="bottom-end" width={230} shadow="md">
      <Menu.Target>
        <Button
          ref={targetRef}
          variant="default"
          px="xs"
          mih={44}
          maw="100%"
          disabled={disabled}
          aria-label={t('OrdersPage:viewSelector.currentView', { view: currentView })}
          leftSection={showTableView ? <IconColumns size={16} /> : <IconLayoutGrid size={16} />}
          rightSection={<IconChevronDown size={14} />}
        >
          {currentView}
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          mih={44}
          disabled={disabled}
          leftSection={<IconLayoutGrid size={16} />}
          rightSection={!showTableView ? <IconCheck size={16} aria-hidden /> : null}
          aria-current={!showTableView ? true : undefined}
          onClick={() => {
            onShowTableViewChange(false);
            targetRef.current?.focus();
          }}
        >
          {t('OrdersPage:viewSelector.cards')}
        </Menu.Item>
        <Menu.Item
          mih={44}
          disabled={disabled}
          leftSection={<IconColumns size={16} />}
          rightSection={showTableView ? <IconCheck size={16} aria-hidden /> : null}
          aria-current={showTableView ? true : undefined}
          onClick={() => {
            onShowTableViewChange(true);
            targetRef.current?.focus();
          }}
        >
          {t('OrdersPage:viewSelector.table')}
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item
          mih={44}
          disabled={disabled || !hasSingleStore}
          leftSection={<IconLayoutKanban size={16} />}
          onClick={() => {
            if (!disabled && hasSingleStore) {
              history.push({
                pathname: '/work-board',
                search: `?storeId=${encodeURIComponent(storeId)}`
              });
            }
          }}
        >
          {t('WorkBoard:title')}
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
